var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "input-group", class: _vm.computedClasses }, [
    _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "span",
        {
          staticClass: "input-group-text",
          class: { ..._vm.activeClass, ..._vm.labelClass },
        },
        [_vm._t("default")],
        2
      ),
    ]),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model.trim",
          value: _vm.valueCopy,
          expression: "valueCopy",
          modifiers: { trim: true },
        },
      ],
      staticClass: "form-control",
      class: _vm.inputClasses,
      attrs: {
        id: _vm.id,
        type: _vm.type,
        "data-toggle": "tooltip-city",
        name: _vm.name,
        placeholder: _vm.placeholder,
        title: _vm.title,
        readonly: _vm.readonly,
        disabled: _vm.disabled,
        autocomplete: _vm.autocomplete,
        max: _vm.max,
        min: _vm.min,
        step: _vm.step,
        minlength: _vm.minlength,
        maxlength: _vm.maxlength,
        required: _vm.required,
      },
      domProps: { value: _vm.valueCopy },
      on: {
        focus: function ($event) {
          return _vm.handleFocus(true)
        },
        blur: [
          function ($event) {
            return _vm.handleFocus(false)
          },
          function ($event) {
            return _vm.$forceUpdate()
          },
        ],
        input: [
          function ($event) {
            if ($event.target.composing) return
            _vm.valueCopy = $event.target.value.trim()
          },
          _vm.handleModelInput,
        ],
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown",
              ])
            )
              return null
            return _vm.onKeyDown.apply(null, arguments)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            )
              return null
            return _vm.onKeyUp.apply(null, arguments)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.onKeyEnter.apply(null, arguments)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
            )
              return null
            return _vm.onKeyEnter.apply(null, arguments)
          },
        ],
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }